import { FramingSelections } from '../../../components/Checkout/Framing/types';
import { GeneratedLinkedDrawEntryIntentLineItemInput } from '../../../types/generated';
import { buildFrameOptionalItems, sameOrderItems } from './orderItems';

type BuildLinkedDrawLineItemsArgs = {
  framingSelections: FramingSelections;
  productIdByDrawId: Map<string, string>;
  selectedDraws: string[];
};

export const buildLinkedDrawLineItems = ({
  framingSelections,
  productIdByDrawId,
  selectedDraws,
}: BuildLinkedDrawLineItemsArgs): GeneratedLinkedDrawEntryIntentLineItemInput[] =>
  selectedDraws.map((drawId, index) => {
    const productId = productIdByDrawId.get(drawId);

    return {
      drawId,
      preference: index + 1,
      framelItems: buildFrameOptionalItems(
        productId ? framingSelections[productId] : undefined,
      ),
    };
  });

const sameLineItem = (
  a: GeneratedLinkedDrawEntryIntentLineItemInput,
  b: GeneratedLinkedDrawEntryIntentLineItemInput,
): boolean => {
  return (
    a.drawId === b.drawId &&
    a.preference === b.preference &&
    sameOrderItems(a.framelItems, b.framelItems)
  );
};

export const sameLinkedDrawLineItems = (
  a: GeneratedLinkedDrawEntryIntentLineItemInput[],
  b: GeneratedLinkedDrawEntryIntentLineItemInput[],
): boolean => {
  return (
    a.length === b.length &&
    a.every((lineItem, index) => {
      return sameLineItem(lineItem, b[index]);
    })
  );
};
